// extracted by mini-css-extract-plugin
export var editInput = "_f5-0";
export var editInputCompact = "_f5-2";
export var editInputLarge = "_f5-1";
export var editInputSmall = "_f5-3";